export const SUPER_ADMIN_ACCESS = ['ROLE_SUPER_ADMIN'];

export const ADMIN_ACCESS = ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'];

export const USER_ACCESS = ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_USER'];

export const CUSTOMER_ACCESS = ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CUSTOMER'];

export const ALL_ACCESS = ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CUSTOMER'];
